<template>
  <form class="mt" @submit.prevent="onSubmit">
    <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">{{errorMessage}}</b-alert>
    <div class="form-group" v-if="item && item.id">
      <label for="id">ID: {{item.id}}</label>
    </div>

    <div class="form-group">
      <label for="name">Nombre del contacto</label>
      <input
        class="form-control"
        type="text"
        name="name"
        id="name"
        placeholder="Nombre del contacto"
        v-validate="'required'"
        v-model="item.name"
        autocomplete="off"
        maxlength="200"
      />
    </div>
    <div class="form-group">
      <label for="phone">Teléfono</label>
      <input
        class="form-control"
        type="text"
        name="phone"
        id="phone"
        placeholder="Teléfono"
        v-validate="'required'"
        v-model="item.phone"
        autocomplete="off"
        maxlength="10"
      />
    </div>
    <div class="form-group">
      <label for="email">Email</label>
      <input
        class="form-control"
        type="text"
        name="email"
        id="email"
        placeholder="Email"
        v-validate="'required|email'"
        v-model="item.email"
        autocomplete="off"
        maxlength="200"
      />
    </div>
    <div class="clearfix">
      <div class="btn-toolbar float-right pb-4">
        <base-button
          native-type="submit"
          type="primary"
          class="mb-3"
          size="sm"
          block
          :loading="s_loading"
        >Guardar</base-button>
      </div>
    </div>
  </form>
</template>

<script>
import BaseComponent from "@/pages/components/BaseComponent";
export default {
  extends: BaseComponent,
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      errorMessage: ""
    };
  },
  computed: {
    isFormValid() {
      return !Object.keys(this.veeFields).some(
        key => this.veeFields[key].invalid
      );
    }
  },
  methods: {
    onSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.s_loading = true;
          // console.log("this.item", this.item);
          if (!this.item.id) {
            this.axioPost({
              url: "Contact/AddAsync",
              value: this.item
            });
          } else {
            // console.log("this.item", this.item);
            this.axioPut({
              url: "Contact/UpdateAsync",
              value: this.item
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
